import BeachIcon from "../assets/share/icon/beach.svg";
import CulinaryIcon from "../assets/share/icon/culinary.svg";
import CultureIcon from "../assets/share/icon/culture.svg";
import GolfIcon from "../assets/share/icon/golf.svg";
import MusicIcon from "../assets/share/icon/music.svg";
import SkiIcon from "../assets/share/icon/ski.svg";
import SpaIcon from "../assets/share/icon/spa.svg";
import PaddleIcon from "../assets/share/icon/paddle.svg";
import BikeIcon from "../assets/share/icon/bike.svg";
import FishIcon from "../assets/share/icon/fish.svg";
import DiveIcon from "../assets/share/icon/dive.svg";
import SafariIcon from "../assets/share/icon/safari.svg";
import SurfIcon from "../assets/share/icon/surf.svg";
import HikeIcon from "../assets/share/icon/hike.svg";

export const allPassions = [
  { label: "Golf", icon: GolfIcon },
  { label: "Beach", icon: BeachIcon },
  { label: "Ski", icon: SkiIcon },
  { label: "Culinary", icon: CulinaryIcon },
  { label: "Culture", icon: CultureIcon },
  { label: "Music", icon: MusicIcon },
  { label: "Paddle", icon: PaddleIcon },
  { label: "Bike", icon: BikeIcon },
  { label: "Fish", icon: FishIcon },
  { label: "Dive", icon: DiveIcon },
  { label: "Safari", icon: SafariIcon },
  { label: "Spa", icon: SpaIcon },
  { label: "Surf", icon: SurfIcon },
  { label: "Hike", icon: HikeIcon },
];

export const passionsParams = [
  "golf",
  "beach",
  "ski",
  "culinary",
  "culture",
  "music",
  "paddle",
  "bike",
  "fish",
  "dive",
  "safari",
  "spa",
  "surf",
  "hike",
];

export function getPassionHeader(passion) {
  switch (passion) {
    case "golf":
      return "Explore more golf";
    case "culture":
      return "Explore more arts & culture";
    case "culinary":
      return "Explore more culinary";
    case "spa":
      return "Explore more spa";
    case "beach":
      return "Explore more beach";
    case "music":
      return "Explore more music";
    case "ski":
      return "Explore more skiing & snowboarding";
    case "paddle":
      return "Explore more paddle sports";
    case "bike":
      return "Explore more biking";
    case "dive":
      return "Explore more scuba & snorkling";
    case "fish":
      return "Explore more fishing";
    case "safari":
      return "Explore more wildlife safaris";
    case "surf":
      return "Explore more surf destinations";
    case "hike":
      return "Explore more hiking";
    case "am-drinks":
      return "Explore morning beverages";
    case "afternoon-drinks":
      return "Explore afternoon refreshments";
    case "evening-drinks":
      return "Explore evening drinks";
    default:
      return "Explore more";
  }
}
